import React, { useState, useEffect, useCallback } from "react";
import { FaInfoCircle } from "react-icons/fa";
import appStyle from "./appStyle.module.css";

const InputDisplay = ({
  placeholder,
  handleSave,
  maxWords = 100,
  initialValue = "",
  defaultValue = "",
  onInfoClick,
}) => {
  // The "current" value shown in the input
  const [inputValue, setInputValue] = useState(initialValue || defaultValue);
  // The "saved" value — used to detect dirty state
  const [savedValue, setSavedValue] = useState(initialValue || defaultValue);

  // Keep in sync if parent pushes new initialValue externally
  useEffect(() => {
    setInputValue(initialValue || defaultValue);
    setSavedValue(initialValue || defaultValue);
  }, [initialValue, defaultValue]);

  const handleChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleReset = () => {
    // Reset back to the last saved value (not to empty)
    setInputValue(savedValue);
  };

  const handleSaveClick = () => {
    handleSave(inputValue);
    setSavedValue(inputValue);
  };

  // Dirty detection
  const isDirty = inputValue !== savedValue;

  const wordCount = inputValue.trim().split(/\s+/).filter(Boolean).length;
  const isOverLimit = wordCount > maxWords;

  const isSaveDisabled = !isDirty || isOverLimit;
  const isResetDisabled = !isDirty;

  return (
    <div className={appStyle.mesgWrapper}>
      <div className={appStyle.message_wrapper}>
        <div className={appStyle.message_input}>
          <div className={appStyle.inputHeaderRow}>
            <input
              type="text"
              placeholder={placeholder}
              value={inputValue}
              onChange={handleChange}
              className={appStyle.message_input_box}
            />
            {onInfoClick && (
              <FaInfoCircle
                className={appStyle.suggestion_icon}
                onClick={onInfoClick}
                title="More info"
              />
            )}
          </div>

          <div className={appStyle.actions_leftWord_wrap}>
            <div className={appStyle.act_btn}>
              <button
                onClick={handleReset}
                className={appStyle.resetBtn}
                disabled={isResetDisabled}
                style={{
                  opacity: isResetDisabled ? 0.5 : 1,
                  cursor: isResetDisabled ? "not-allowed" : "pointer",
                }}
              >
                Reset
              </button>
              <button
                onClick={handleSaveClick}
                className={appStyle.sendMsg}
                disabled={isSaveDisabled}
                style={{
                  opacity: isSaveDisabled ? 0.5 : 1,
                  cursor: isSaveDisabled ? "not-allowed" : "pointer",
                }}
              >
                Save
              </button>
            </div>

            <div className={appStyle.message_preview}>
              <p>{inputValue}</p>
              <p
                style={{
                  fontSize: "0.9rem",
                  color: isOverLimit ? "red" : "gray",
                  fontStyle: "italic",
                }}
              >
                {isOverLimit
                  ? `⚠️ Limit exceeded (${wordCount}/${maxWords} words)`
                  : `${maxWords - wordCount} words remaining`}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InputDisplay;